import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Sales Support',
            children: [
                { name: 'Buildings', route: 'buildings', type: 'building' },
                { name: 'Building Levels', route: 'building_levels', type: 'building_level' },
                { name: 'Building Units', route: 'building_units', type: 'building_unit' },
            ],
            color: 'navy',
            group: 'sales',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        /* {
            name: 'Banners',
            route: 'banners',
            type: 'banner',
            iconClass: 'kt-menu__link-icon flaticon2-chat-2',
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.MessageSquareIcon,
        }, */

        /* {
            group: 'Collection',
            name: 'Villages',
            route: 'villages',
            iconClass: 'material-icons',
            color: 'navy',
            iconComponent: FeatherIcons.HomeIcon,
        }, */
       /*  {
            group: 'Staff',
            name: 'Staff',
            route: 'staff_members',
            iconClass: 'material-icons',
            iconName: 'sentiment_satisfied_alt',
            color: 'navy',
            iconComponent: FeatherIcons.UsersIcon,
        }, */

        {
            name: 'News',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        /* {
            name: 'Video',
            children: [
                { name: 'Videos', route: 'videos', type: 'videos' },
            ],
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.VideoIcon,
        },
        {
            group: 'media',
            name: 'Galleries',
            route: 'galleries',
            iconClass: 'material-icons',
            color: 'navy',
            iconComponent: FeatherIcons.ImageIcon,
        }, */

        {
            name: 'Customers',
            ...{ name: 'Customers', route: 'customers', type: 'customer' },
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Enquiries',
            route: 'enquiries', type: 'enquiry',
            // children: [
                // { name: 'All Enquiries', route: 'enquiries', type: 'enquiry' },
                // { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            // ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
       /*  {
            name: 'Reports',
            children: [
                { name: 'Search Log', route: 'search_log' },
                { name: 'Customer Logins', route: 'customer_login_logs' },
                { name: 'Customer Favourites', route: 'customers_listings' },
            ],
            color: 'navy',
            group: 'reports',
            iconComponent: FeatherIcons.BarChart2Icon,
        }, */
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users' },
                { name: 'Roles', route: 'roles' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
